import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../../contexts/AuthProvider/AuthProvider';

const OrderAndPay = ({wishlist}) => {
    const {_id, category_id, product_id,product_title,image,order_status,payment_status,payment_method,seller_name,seller_email,
        date,buyer_name,buyer_email,price,buyer_phone,meeting_location} = wishlist;
    
    const {successMessage} = useContext(AuthContext);
    const navigate = useNavigate();

    const handleSubmitWishlist = () => {

        const wishlist = {
            category_id,
            product_id,
            product_title,
            image,
            order_status,
            payment_status,
            payment_method,
            seller_name,
            seller_email,
            date,
            buyer_name,
            buyer_email,
            price,
            buyer_phone,
            meeting_location,
            card_number:'',
            date_format_cbc:'',
        };

        fetch('https://used-products-resale-market-server.vercel.app/orders', {
            method: 'POST',
            headers: {
                'content-type': 'application/json', 
            },
            body: JSON.stringify(wishlist)
        })
        .then(res => res.json())
        .then(result =>{
            if(result.acknowledged){
                const orderId = result.insertedId;

                fetch(`https://used-products-resale-market-server.vercel.app/wishlists/${_id}`, {
                    method: 'DELETE', 
                })
                .then(res => res.json())
                .then(data => {
                    if(data.deletedCount > 0){
                        successMessage();
                        navigate(`/buyer-dashboard/orders/checkout/${orderId}`);
                    }
                })
            }
        })
        .catch(err => console.error(err));
    } 
    return (
        <>
            {/* <form> */}
                <button onClick={handleSubmitWishlist} type='submit' className='btn btn-success'>Booked & Pay Now</button>
            {/* </form> */}
        </>
    );
};

export default OrderAndPay;